import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { getUuidV4, handleNumberOnly, validarCNPJ, validarCPFCNPJ } from "../../../utils/utils";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../app/store";
import { useEffect, useState } from "react";
import { addAuthDownload, removeAuthDownload } from "../../../features/manifestoSlice";
import { AutorizacaoDownloadInterface } from "../../../interfaces";
import { JConfirmDelete, MensagemModal } from "../../../components/Components";

const limite = 10;

const initialForm : AutorizacaoDownloadInterface = {
    id: 0,
    cpfcnpj: '',
}

export default function AutorizacaoDownload() {
    const dispatch = useDispatch();
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.authDownload);
    const [form, setForm]  = useState<AutorizacaoDownloadInterface>(initialForm);
    const [showAlert, setShowAlert] = useState<boolean>(false); 
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [selected, setSelected] = useState<AutorizacaoDownloadInterface>(initialForm);
    const [showModal, setShowModal] = useState<boolean>(false); 
    const [saldo, setSaldo] = useState<number>(0);

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialForm);
    }

    const handleOpenModal = (value: AutorizacaoDownloadInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const validarPreenchimento = () => {

        if (form.cpfcnpj === "") {
            alerta('Informe um CNPJ.');
            return false;
        }
        
        if (!validarCNPJ(form.cpfcnpj)) {
            alerta('CNPJ inválido.');
            return false;
        }

        if (lista.length >= limite) {
            alerta('Limite máximo de 10 autorizações de download atingido.');
            return false;
        }

        if (lista.find(item => item.cpfcnpj === form.cpfcnpj)) {
            alerta('CNPJ já adicionado.');
            return false; 
        }

        return true;
    }

    const handleChange = (e: any) => {
        const {name, value} = e.target;
        
        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleAdd = () => {
        if (validarPreenchimento()) {
            dispatch(addAuthDownload({...form, id: getUuidV4()}));
            setForm(initialForm);
        }
    }

    const handleRemove = (id: number) => {
        dispatch(removeAuthDownload(id));
        setShowModal(false);
        setSelected(initialForm);
    }

    useEffect(()=> {
        setSaldo( lista.length);
    }, [lista]  )

    return <div className="px-2">
        <Row className="g-2 mb-3">
            <Col md={'auto'} className="">
                <Form.Group  >
                    <Form.Label>CNPJ</Form.Label>
                    <Form.Control name="cpfcnpj" maxLength={14} type="text" 
                        onKeyUp={handleNumberOnly} onChange={handleChange}  value={form.cpfcnpj}
                    />
                </Form.Group>
            </Col>

            <Col md={'auto'} className="d-flex align-items-end">
                <Form.Group >
                    <Button variant="primary" onClick={handleAdd}>
                        <FontAwesomeIcon icon={faPlus}/>  Adicionar
                    </Button>
                </Form.Group>
            </Col>
        </Row>

        <Row >
            <h6 >({saldo} de {limite} no máximo)</h6>
        </Row>

        <Table striped bordered hover size="sm">
            <thead className="table-light">
                <tr>
                    <th className="text-center" style={{width: '2.5rem'}}>#</th>
                    <th>CNPJ</th>
                </tr>
            </thead>

            <tbody>
                {lista?.map((item: AutorizacaoDownloadInterface) => (
                    <tr key={item.id}>
                        <td className="text-center">
                            <a href="javasctipt:void(0)" className="text-danger" 
                                onClick={() => handleOpenModal({id: item.id, cpfcnpj: item.cpfcnpj})}>
                                <FontAwesomeIcon icon={faTrash} />
                            </a>
                        </td>
                        <td>{item.cpfcnpj}</td>
                    </tr>
                )) } 
            </tbody>
        </Table>

        <JConfirmDelete 
            showModal={showModal} 
            handleCloseModal={handleCloseModal} 
            handleDelete={handleRemove} 
            selectedObject={selected.cpfcnpj} 
            id={selected.id}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />

    </div>
}
